var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronNextInactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    width: 20,
    height: 20,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Chevron_Next_Active") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.s0 { fill: #ffffff } \n\t")), /*#__PURE__*/React.createElement("g", {
    id: "Down",
    style: {
      opacity: 0.5
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "X-/-Dashboard"
  }, /*#__PURE__*/React.createElement("g", {
    id: "X-/-NWAS-/-Dash"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Cards"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Button-/-Disclosure-/-Up"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon-Colour",
    className: "s0",
    d: "m8.4 16l-1.4-1.4 4.3-4.3-4.3-4.3 1.4-1.4 5.7 5.7z"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronNextInactive);
export default __webpack_public_path__ + "static/media/Chevron_Next_Inactive.8d304b95bd7186ee02681f48f6bd5ea2.svg";
export { ForwardRef as ReactComponent };